import {IPhoneFieldValue} from "@pg-design/phone-input-module";
import {getPhoneDataFromString} from "@pg-mono/string-utils";

const POLISH_PHONE_CODE = 48;
const POLISH_PHONE_NUMBER_DIGITS_COUNT = 9;
const FOREIGN_PHONE_NUMBER_MIN_DIGITS_COUNT = 6;
const FOREIGN_PHONE_NUMBER_MAX_DIGITS_COUNT = 15;

const isPolishPhoneCode = (code: number) => Number(code) === POLISH_PHONE_CODE;

export const getPhoneDigits = (number: string) => number.replace(/\D/g, "");

export const hasValidPhoneNumberLength = (phone: IPhoneFieldValue) => {
    const digitsCount = getPhoneDigits(phone.number).length;

    if (isPolishPhoneCode(phone.code)) {
        return digitsCount === POLISH_PHONE_NUMBER_DIGITS_COUNT;
    }

    return digitsCount >= FOREIGN_PHONE_NUMBER_MIN_DIGITS_COUNT && digitsCount <= FOREIGN_PHONE_NUMBER_MAX_DIGITS_COUNT;
};

export const getPhoneNumberLengthMessage = (code: number) =>
    isPolishPhoneCode(code)
        ? `Numer telefonu musi mieć ${POLISH_PHONE_NUMBER_DIGITS_COUNT} cyfr`
        : `Numer telefonu musi mieć od ${FOREIGN_PHONE_NUMBER_MIN_DIGITS_COUNT} do ${FOREIGN_PHONE_NUMBER_MAX_DIGITS_COUNT} cyfr`;

export const getProfilePhoneValue = (phone: string | null | undefined): IPhoneFieldValue | null => {
    if (!phone?.trim()) {
        return null;
    }

    return getPhoneDataFromString(phone.trim());
};

export const getProfilePhoneString = (phone: IPhoneFieldValue) => `${phone.code} ${getPhoneDigits(phone.number)}`;

export const getSmsLoginPhoneString = (phone: IPhoneFieldValue) => `+${phone.code}${getPhoneDigits(phone.number)}`;

export const isSamePhone = (first: IPhoneFieldValue | null | undefined, second: IPhoneFieldValue | null | undefined) =>
    Boolean(first && second && Number(first.code) === Number(second.code) && getPhoneDigits(first.number) === getPhoneDigits(second.number));

export const getMaskedPhone = (phone: IPhoneFieldValue) => {
    const digits = getPhoneDigits(phone.number);
    // Keep at least one digit hidden, even for short international numbers.
    const visibleDigitsCount = Math.min(3, Math.floor((digits.length - 1) / 2));

    if (visibleDigitsCount <= 0) {
        return `+${phone.code} ***`;
    }

    return `+${phone.code} ${digits.slice(0, visibleDigitsCount)} *** ${digits.slice(-visibleDigitsCount)}`;
};
import {IPhoneFieldValue} from "@pg-design/phone-input-module";
import {getPhoneDataFromString} from "@pg-mono/string-utils";

const POLISH_PHONE_CODE = 48;
const POLISH_PHONE_NUMBER_DIGITS_COUNT = 9;
const FOREIGN_PHONE_NUMBER_MIN_DIGITS_COUNT = 6;
const FOREIGN_PHONE_NUMBER_MAX_DIGITS_COUNT = 15;

const isPolishPhoneCode = (code: number) => Number(code) === POLISH_PHONE_CODE;

export const getPhoneDigits = (number: string) => number.replace(/\D/g, "");

export const hasValidPhoneNumberLength = (phone: IPhoneFieldValue) => {
    const digitsCount = getPhoneDigits(phone.number).length;

    if (isPolishPhoneCode(phone.code)) {
        return digitsCount === POLISH_PHONE_NUMBER_DIGITS_COUNT;
    }

    return digitsCount >= FOREIGN_PHONE_NUMBER_MIN_DIGITS_COUNT && digitsCount <= FOREIGN_PHONE_NUMBER_MAX_DIGITS_COUNT;
};

export const getPhoneNumberLengthMessage = (code: number) =>
    isPolishPhoneCode(code)
        ? `Numer telefonu musi mieć ${POLISH_PHONE_NUMBER_DIGITS_COUNT} cyfr`
        : `Numer telefonu musi mieć od ${FOREIGN_PHONE_NUMBER_MIN_DIGITS_COUNT} do ${FOREIGN_PHONE_NUMBER_MAX_DIGITS_COUNT} cyfr`;

export const getProfilePhoneValue = (phone: string | null | undefined): IPhoneFieldValue | null => {
    if (!phone?.trim()) {
        return null;
    }

    return getPhoneDataFromString(phone.trim());
};

export const getProfilePhoneString = (phone: IPhoneFieldValue) => `${phone.code} ${getPhoneDigits(phone.number)}`;

export const getSmsLoginPhoneString = (phone: IPhoneFieldValue) => `+${phone.code}${getPhoneDigits(phone.number)}`;

export const isSamePhone = (first: IPhoneFieldValue | null | undefined, second: IPhoneFieldValue | null | undefined) =>
    Boolean(first && second && Number(first.code) === Number(second.code) && getPhoneDigits(first.number) === getPhoneDigits(second.number));

export const getMaskedPhone = (phone: IPhoneFieldValue) => {
    const digits = getPhoneDigits(phone.number);
    // Keep at least one digit hidden, even for short international numbers.
    const visibleDigitsCount = Math.min(3, Math.floor((digits.length - 1) / 2));

    if (visibleDigitsCount <= 0) {
        return `+${phone.code} ***`;
    }

    return `+${phone.code} ${digits.slice(0, visibleDigitsCount)} *** ${digits.slice(-visibleDigitsCount)}`;
};
